import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tank-circle',
  templateUrl: './tank-circle.component.html',
  styleUrls: ['./tank-circle.component.css']
})
export class TankCircleComponent implements OnInit {

  height = 80;
  color = 'green';
  @Input() tankValue: any;

  constructor() { }

  ngOnInit(): void {
    this.height = (+this.tankValue?.lastInventory / +this.tankValue?.tankcapacity) * 100;
    if (this.height < 30) {
      this.color = "#e62e36";
    } else if (this.height < 60) {
      this.color = "#efa81e";
    } else {
      this.color = "#3c8243";
    }
  }

}
